// gloss
type TimeSlot = { date: string; time: string; [key: string]: unknown };

// gloss
export const groupSlotsByDate = (slots: TimeSlot[] | null | undefined): Record<string, TimeSlot[]> => {
  if (!slots) return {};

  const grouped = slots.reduce<Record<string, TimeSlot[]>>((acc, slot) => {
    const group = acc[slot.date] ?? [];
    acc[slot.date] = group;
    const exists = group.some((existing) => existing.time === slot.time);
    if (!exists) {
      group.push(slot);
    }
    return acc;
  }, {});

  for (const date of Object.keys(grouped)) {
    grouped[date]?.sort((a, b) =>
      convertTo24Hour(a.time).padStart(5, '0').localeCompare(convertTo24Hour(b.time).padStart(5, '0')),
    );
  }

  return grouped;
};

// gloss
export const convertTo24Hour = (time12h: string | null | undefined): string => {
  if (typeof time12h !== 'string' || time12h.length === 0) return '00:00';
  const splitTime = time12h.split(' ');
  const time = splitTime[0] ?? '';
  const modifier = splitTime[1] ?? '';
  if (time.length === 0) return '00:00';
  const parts = time.split(':');
  let hours = parts[0] ?? '00';
  const minutes = parts[1] ?? '00';

  if (hours === '12') {
    hours = '00';
  }
  if (modifier === 'PM') {
    hours = String(parseInt(hours, 10) + 12);
  }

  return `${hours.padStart(2, '0')}:${minutes}`;
};

// gloss
export const formatTimeRange = (startTime: string | null | undefined): string => {
  if (typeof startTime !== 'string' || startTime.length === 0) return '';
  const splitStart = startTime.split(' ');
  const time = splitStart[0] ?? '';
  const modifier = splitStart[1] ?? '';
  if (time.length === 0) return '';
  const parts = time.split(':');
  const hours = parts[0] ?? '0';
  const minutes = parts[1] ?? '00';

  const date = new Date();
  date.setHours(
    modifier === 'PM' && hours !== '12'
      ? parseInt(hours, 10) + 12
      : modifier === 'AM' && hours === '12'
        ? 0
        : parseInt(hours, 10),
    parseInt(minutes, 10) || 0,
  );

  const endDate = new Date(date);
  endDate.setMinutes(date.getMinutes() + 30);

  const endHours = endDate.getHours();
  const endMinutes = endDate.getMinutes();
  const formattedEndHours = endHours > 12 ? endHours - 12 : endHours === 0 ? 12 : endHours;
  const end = `${formattedEndHours}:${endMinutes.toString().padStart(2, '0')}`;

  const endModifier = endHours >= 12 ? 'PM' : 'AM';
  if (modifier && modifier !== endModifier) {
    return `${hours}:${minutes} ${modifier}-${end} ${endModifier}`;
  }
  return `${hours}:${minutes}-${end} ${modifier}`;
};
